"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlTransformProvider = void 0;
const rc_js_util_1 = require("rc-js-util");
const transform_buffer_provider_1 = require("../../transform-components/transform-buffer-provider");
/**
 * @public
 */
class GlTransformProvider {
    constructor(transformKey, binder, getUserTransform, getBinderConnector) {
        this.transformKey = transformKey;
        this.binder = binder;
        this.getUserTransform = getUserTransform;
        this.getBinderConnector = getBinderConnector;
        this.transformComponent = null;
        this.groupId = rc_js_util_1._Identifier.getNextIncrementingId();
        this.bufferLayoutProvider = new transform_buffer_provider_1.TransformBufferProvider(binder);
    }
    static createOne(transformKey, binder, getUserTransform, getEntityChangeId) {
        return new GlTransformProvider(transformKey, binder, getUserTransform, getEntityChangeId);
    }
    getTransformBinder() {
        return this.binder.getTransformBinder();
    }
    updateTransform(renderer, updateArg) {
        const userTransformId = this.getUserTransform(updateArg).userTransformId;
        this.transformComponent = rc_js_util_1._Fp.normalizeToNull(renderer.transformComponents.getTransform(userTransformId, this.transformKey));
    }
    setOutputBuffers(entity, transformRenderer) {
        if (this.transformComponent == null) {
            return;
        }
        this.transformComponent.setOutputBuffers(entity, this.binder, transformRenderer);
    }
    setGroupId(id) {
        this.groupId = id;
    }
    isTransformRequired(entity, updateArg) {
        if (this.transformComponent == null) {
            return false;
        }
        const connector = this.getBinderConnector(entity, updateArg);
        return this.binder.areAttributesDirty(connector);
    }
}
exports.GlTransformProvider = GlTransformProvider;
//# sourceMappingURL=gl-transform-provider.js.map